import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";
import ActivitiesContent from "./ActivitiesContent";
import VenuesContent from "./VenuesContent";
import ProfileContent from "./ProfileContent"; // Import ProfileContent

const ManagerDashboard = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [activeTab, setActiveTab] = useState(
        localStorage.getItem("activeTab") || "venues" // Load the saved tab or default to "venues"
    );

    const { user, tokens, logout } = useContext(AuthContext);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const handleTabChange = (tab) => {
        // Force reload by resetting and then setting the activeTab
        setActiveTab(""); // Temporarily unset activeTab
        setTimeout(() => {
            setActiveTab(tab); // Set the desired tab
            localStorage.setItem("activeTab", tab); // Save the tab to localStorage
        }, 0);
    };

    const renderContent = () => {
        switch (activeTab) {
            case "activities":
                return <ActivitiesContent />;
            case "venues":
                return <VenuesContent />;
            case "profile":
                return <ProfileContent />;
            default:
                return <VenuesContent />;
        }
    };

    const handleLogout = async () => {
        try {
            await logout({ accessToken: tokens.accessToken, refreshToken: tokens.refreshToken });
            console.log("Logged out successfully");
        } catch (error) {
            console.error("Failed to logout:", error.message);
        }
    };

    useEffect(() => {
        const savedTab = localStorage.getItem("activeTab");
        if (savedTab) {
            setActiveTab(savedTab); // Restore the tab on page refresh
        }
    }, []);

    return (
        <div className="flex h-screen overflow-hidden">
            {/* Sidebar */}
            <div
                className={`bg-dark text-white flex flex-col ${
                    isSidebarOpen ? "w-64" : "w-16"
                } transition-all duration-300`}
            >
                {/* Sidebar Header */}
                <div className="p-4 border-b border-gray-700 flex items-center justify-between">
                    <span className={`text-xl font-bold ${isSidebarOpen ? "block" : "hidden"}`}>
                        {isSidebarOpen ? `Welcome, ${user?.username || "Manager"}!` : ""}
                    </span>
                    <button
                        onClick={toggleSidebar}
                        className="text-gray-400 hover:text-white"
                    >
                        ☰
                    </button>
                </div>

                {/* Sidebar Links */}
                <nav className="p-4 flex flex-col space-y-4">
                    <button
                        onClick={() => handleTabChange("venues")}
                        className={`flex items-center space-x-2 hover:text-gray-400 ${
                            activeTab === "venues" ? "text-white font-bold" : ""
                        }`}
                    >
                        <i className="fas fa-map-marker-alt"></i>
                        <span className={isSidebarOpen ? "block" : "hidden"}>Venues</span>
                    </button>
                    <button
                        onClick={() => handleTabChange("activities")}
                        className={`flex items-center space-x-2 hover:text-gray-400 ${
                            activeTab === "activities" ? "text-white font-bold" : ""
                        }`}
                    >
                        <i className="fas fa-tasks"></i>
                        <span className={isSidebarOpen ? "block" : "hidden"}>Activities</span>
                    </button>
                    <button
                        onClick={() => handleTabChange("profile")}
                        className={`flex items-center space-x-2 hover:text-gray-400 ${
                            activeTab === "profile" ? "text-white font-bold" : ""
                        }`}
                    >
                        <i className="fas fa-user"></i>
                        <span className={isSidebarOpen ? "block" : "hidden"}>Profile</span>
                    </button>
                </nav>
            </div>

            {/* Main Content */}
            <div className="flex-1 flex flex-col bg-light overflow-auto">
                {/* Top Navbar */}
                <div className="bg-white shadow p-4 flex items-center justify-between">
                    <div className="flex items-center space-x-4">
                        <span className="text-lg font-bold">Manager Dashboard</span>
                    </div>
                    <div className="flex items-center space-x-4">
                        <button
                            className="text-gray-600 hover:text-gray-900 flex items-center space-x-2"
                            onClick={handleLogout}
                        >
                            <i className="fas fa-sign-out-alt text-xl"></i>
                            <span>Logout</span>
                        </button>
                    </div>
                </div>

                {/* Main Content Area */}
                <div className="p-6">{renderContent()}</div>
            </div>
        </div>
    );
};

export default ManagerDashboard;
